export default class ProviderShiftContextCodes {
  static OPEN = 'PROVIDERINCENTIVECONTEXT_OPEN';
  static SCHEDULED = 'PROVIDERINCENTIVECONTEXT_CONSULT';
  static SCHEDULED_SHIFT = 'PROVIDERINCENTIVECONTEXT_SHIFT';
  static PREFERRED_PROVIDER = 'PROVIDERINCENTIVECONTEXT_FORECAST';
}
